import mrpStyles from './mrpRtl.json'
import mediaQuery from './mediaQuery'
import * as theme from './mrp/index'
import * as themeRtl from './mrpRtl/index'
import motionSpecs from './motionSpecs'
import typestack from './typestack'

export default {
  direction: 'rtl',
  typography: mrpStyles,
  baseOverrides: theme.baseOverrides,
  breakpoints: theme.breakpoints,
  spacingMultiplier: 8,
  rowOffsetTopSmall: 3,
  rowOffsetTopMedium: 4,
  rowOffsetTopLarge: 6,
  rowOffsetTopXLarge: 6,
  rightOffset: 3,
  fullBleed: true,
  mediaQuery,
  motionSpecs,
  typestack: typestack['mrp-ar'],
  custom: {
    ...theme,
    ...themeRtl
  }
}
